import React, { useState, useRef, useEffect } from 'react';
import { Popup, Input, CustomButton, ToastNotification } from 'components';
import { TaskService } from "services/http";
import utils from "utils";

export const TagFormTemplate = (props) => {

    const { title, display, actionType, payload } = props;
    const [loading, setLoading] = useState(false);
    const [tagDescription, setTagDescription] = useState(payload.description);
    const toastRef = useRef();

    useEffect(() => {
        setTagDescription(payload.description);
    }, [payload]);

    //ON SUBMIT NEW TAG ACTION
    const onSubmitAction = () => {
        if (tagDescription) {
            setLoading(true);
            switch (actionType) {
                case 0: {
                    TaskService.updateInterventionTag({ tagId: payload.tagId, description: tagDescription }).then((response) => {
                        props.callbackRefresh();
                        props.hide();
                        toastRef.current?.showToast({ type: "success", title: "Callbak Response", message: response.message });
                    }, error => {
                        toastRef.current?.showToast({ type: "error", title: "Error response", message: error });
                    }).finally(() => setLoading(false));
                    break;
                }
                case 1: {
                    TaskService.addInterventionTag({ description: tagDescription }).then((response) => {
                        props.callbackRefresh();
                        props.hide();
                        toastRef.current?.showToast({ type: "success", title: "Callbak Response", message: response.message });
                    }, error => {
                        toastRef.current?.showToast({ type: "error", title: "Error response", message: error });
                    }).finally(() => setLoading(false));
                    break;
                }
                default: {
                    break;
                }
            }
        } else {
            toastRef.current?.showToast({ type: "warn", title: "Error response", message: "Please enter a tag description" });
        }
    }

    return (
        <>
            <Popup
                header={title}
                visible={display}
                onHide={() => { props.hide(); }}>
                <div style={{ width: "25vw" }}>
                    <Input
                        icon="bi bi-tag"
                        placeholder="#Tag description"
                        value={tagDescription}
                        onChange={(e) => setTagDescription(e.target.value)} />

                    <div className="mt-3 w-100 d-flex">
                        <CustomButton
                            label={<><i className="bi bi-x-circle" /> Discard</>}
                            onClick={() => props.hide(false)}
                            className="p-button-warning"
                            style={{ width: "50%" }} /> &nbsp;
                        <CustomButton
                            label={utils.labelTemplate(<><i className="bi bi-check-circle" /> Submit</>, loading, "Processing...")}
                            type="submit"
                            onClick={onSubmitAction}
                            className={loading && "not-allowed"}
                            style={{ width: "50%" }} />
                    </div>
                </div>
            </Popup>

            <ToastNotification ref={toastRef} />
        </>
    );
}